export default [
  {
    fullName: 'Смирнов Дмитрий',
    jobTitle: 'Веб-разработчик',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/Смирнов_Дмитрий.jpg')
  },
  {
    fullName: 'Митин АЛЕКСАНДР',
    jobTitle: 'Эксперт-разработчик',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/Митин_Александр.jpg')
  },
  {
    fullName: 'ШЕВЧЕНКО МАРК',
    jobTitle: 'Ведущий разработчик',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/sogudhgou.jpg')
  },
  {
    fullName: 'САВИНОВСКИХ АННА',
    jobTitle: 'Ведущий программист',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/Савиновских Анна.jpg')
  }
]
